/**
 * File: apps/qbench-cp/reactapp/src/shared/layout/PortalMainMenu/styles.js
 *
 * Purpose: Styled-components definitions for the PortalMainMenu tab list and its individual tab
 *     links/buttons.
 *
 * Scope: Portal top navigation menu styling for the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Defines StyledPortalMainMenu as the right-aligned flex nav wrapper, StyledTab as a
 *     themed react-router Link tab with hover/active underline states, StyledTabDummy as an
 *     equivalent non-link div for the create-order tab, and StyledTabList as the flex menu list
 *     container. Colors and underline accents come from the active theme's text palette.
 *
 * Exports: StyledPortalMainMenu, StyledTab, StyledTabDummy, StyledTabList styled components.
 */

import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledPortalMainMenu = styled.nav`
	display: flex;
	justify-content: flex-end;
	flex-grow: 1;
`;

const StyledTab = styled(Link)`
	display: flex;
	color: ${props => props.theme.color.palette.text.headerText};
	margin-right: 15px;
	text-decoration: none;

	& > .mobileViewMenu{
		border-bottom: 2px solid transparent;		
		&:hover {
			border-bottom: 2px solid ${props => props.theme.color.palette.text.linkText};
			border-radius: 0px;
		}
	}
	& > button {
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 16px;
		height: fit-content;
		letter-spacing: 0.1px;
		text-align: center;
		white-space: nowrap;
		margin: 8px 24px 0px 24px;
		padding: 0px 0px 8px;
		&:hover {
			border-bottom: 2px solid ${props => props.theme.color.palette.text.headerText};
			border-radius: 0px;
		}
	}
	&:hover {
		text-decoration: none;
	}

	& > .iconContainer {
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 0.6rem;
	}
`;

const StyledTabDummy = styled.div`
	display: flex;
	color: ${props => props.theme.color.palette.text.headerText};
	margin-right: 15px;

	& > .mobileViewMenu{
		border-bottom: 2px solid transparent;		
		&:hover {
			border-bottom: 2px solid ${props => props.theme.color.palette.text.linkText};
			border-radius: 0px;
		}
	}
	& > button {
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 16px;
		height: fit-content;
		letter-spacing: 0.1px;
		text-align: center;
		white-space: nowrap;
		margin: 8px 24px 0px 24px;
		padding: 0px 0px 8px;
		&:hover {
			border-bottom: 2px solid ${props => props.theme.color.palette.text.headerText};
			border-radius: 0px;
		}
	}
	&:hover {
		text-decoration: none;
	}

	& > .iconContainer {
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 0.6rem;
	}
`;

const StyledTabList = styled.menu`
	display: flex;
	margin: 0;
	padding: 0;
`;

export { StyledPortalMainMenu, StyledTab, StyledTabDummy, StyledTabList };
